import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AppService } from 'app/app.service';
import { Util } from 'app/shared/util';
import { UIGridBaseComponent } from 'app/ui/ui-grid-base.component';

declare const Mangler: any;

@Component({
	selector: 'app-developer-auto',
	templateUrl: './developer-auto.component.html',
	styleUrls: ['./developer-auto.component.scss']
})
export class DeveloperAutoComponent extends UIGridBaseComponent implements OnInit {

	data;
	list = [];
	origin = window.location.origin;
	webhookListSample = [
		{
			id: 3,
			event_type: 'quote_status_changed',
			hook_url: 'https://your-server.com/webhook',
			created_datetime: '2026-08-01 09:15:00'
		}
	];
	webhookInfoSample = {
		webhook_count: 2,
		throttled_count: 1,
		queued_events: 5,
		failed_events: 2,
		webhooks: [
			{
				id: 3,
				event_type: 'quote_status_changed',
				hook_url: 'https://your-server.com/webhook',
				created_datetime: '2026-08-01 09:15:00',
				throttled: true,
				throttled_until: '2026-08-03 12:34:56',
				consecutive_failures: 4,
				queued_events: 5,
				failed_events: 2
			}
		]
	};
	types = [
		{ id: 'webhook', name: 'Webhook', menu: 'Webhooks' },
		{ id: 'list', name: 'List', menu: 'Lists' },
		{ id: 'action', name: 'Action', menu: 'Actions' }
	]

	constructor(
		public app: AppService,
		private http: HttpClient
	) {
		super();
	}

	ngOnInit(): void {
		this.http.get('assets/json/zapier-source.json', { observe: 'response' }).subscribe(response => {
			let text = JSON.stringify(response.body);
			text = text.replace(/{{process.env.BASE_URL}}/g, window.location.origin);
			text = text.replace(/{{bundle.targetUrl}}/g, 'https://your-server.com/webhook');
			text = text.replace(/{{bundle.subscribeData.id}}/g, 'WEBHOOK_ID');
			text = text.replace(/darthjdg@gmail.com/g, 'test@example.com');
			text = text.replace(/dev@wetech.cloud/g, 'test@example.com');
			text = text.replace(/jd@lcris.co.uk/g, 'test@example.com');
			text = text.replace(/yk@yopmail.com/g, 'test@example.com');
			text = text.replace(/3.9.99.189/g, 'wequote.test');
			this.data = JSON.parse(text);

			this.list = [];
			Object.keys(this.data).forEach(type => {
				const group = this.data[type];
				if (Mangler.isObject(group)) {
					Object.keys(group).forEach(key => {
						const item = group[key];
						if (Mangler.isObject(item) && item.key && item.operation) {
							item.type = type;
							this.list.push(item);
						}
					});
				}
			});

			this.list.forEach(item => {
				if (item.type === 'triggers' && item.operation?.performSubscribe) {
					item.type = 'webhook';
				} else if (item.type === 'triggers') {
					item.type = 'list';
				} else {
					item.type = 'action';
				}

				if (item.operation?.canPaginate) {
					if (!item.operation.inputFields) item.operation.inputFields = [];
					item.operation.inputFields.push({
						key: 'page',
						label: 'Page Number',
						type: 'integer',
						required: false
					});
				}

				if (item.key === 'get_quote_lines') {
					if (Mangler.isArray(item.operation?.sample?.lines)) {
						item.operation.sample.lines = item.operation.sample.lines.slice(0, 2);
					}
				}
			});

			this.list.sort((a, b) => {
				const aname = a.display?.label || a.key || '';
				const bname = b.display?.label || b.key || '';
				if (aname < bname) return -1;
				if (aname > bname) return 1;
				return 0;
			});
		}, _error => {
			this.app.notifications.showDanger('Source file not found.');
		});
	}

	scrollTo(navClass) {
		Util.scrollTo(navClass, 'instant');
	}

}
